export default "__VITE_ASSET__1c00392a__"